import {useCallback, useMemo, useState, useEffect} from 'react';
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import {useDispatch, useSelector} from 'react-redux';
import {Daily_Expense} from '../../module-specific-utilities.types';
import {approveExpenseStateSelector} from '@app/screens/module-specific-utilities/pages/approve-expenses/redux/selectors';
import '../approve-expenses/styles/gridStyle.css';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {Box, Button, Link, Tooltip} from '@mui/material';
import {
  approveExpenseStateActions,
  fetchBilDetailsCreator,
  fetchDailyExpenseDcrMapUrlDataCreator,
  fetchDailyExpenseDcrReportDataCreator,
  fetchDailyExpensePopupReadOnlyData,
  fetchDailyExpensePopupTADAData,
  fetchDailyExpensePopupTADASaveData,
} from '@app/screens/module-specific-utilities/pages/approve-expenses/redux/slice';
import {DcrModal} from './DCR-Report-Modal';
import InsufficentFundPopup from './sub-components/InsufficentFundPopup';
import {ViewBillPopup} from './sub-components/ViewBillPopup';
import {TADAPopup} from './ta-da-popup';
import {
  EditIcon,
  colorChange,
  nameStyles,
  referColor,
} from '@app/screens/Styles/style';
import {ToasterService} from '@app/services';
import {ToastType} from '@app/services/toaster';
import {Gridstyle} from '@app/components/widgets/grid/grid';
import {NoRecordsFoundBox, TextInput} from './ApproveExpenseMiscEditableGrid';
import {NumberInput} from './utils/numericcellEdit';
import TravleDetail from './sub-components/TravelDetails';
import {strings} from '@app/common/strings';
import theme from '@app/themes';
import {debounce} from 'lodash';

export const util: any = {
  onRowValueChanged: null,
  onRowEditingStarted: null,
  style1: null,
  style: null,
  handleCellChange: null,
  AdminPassedDaConditionalRendering: null,
};

export const adminPassedDistance = (
  isCellEditable: any,
  style: any,
  sortedDirection: any,
) => {
  return {
    field: strings.moduleSpecificUtilities.adminPassedDistance,
    headerName: strings.moduleSpecificUtilities.ADMINPASSEDDISTANCE,
    width: 106,
    editable: isCellEditable,
    cellEditor: NumberInput,
    cellStyle: (params: any) => {
      if (isCellEditable(params)) {
        return {backgroundColor: theme.colors.yellow[700]};
      }
      return null;
    },
    sort: sortedDirection(strings.moduleSpecificUtilities.adminPassedDistance),
  };
};

const ApproveExpenseDailyGrid = () => {
  const dispatch = useDispatch();
  const tableWidths = useSelector(
    approveExpenseStateSelector.getDailyTableWidth(),
  );
  const [expandedWidth, setExpandedWidth] = useState(tableWidths);
  const [editedDCRids, setEditedDCRids] = useState<any>([]);
  const [expenseId, setExpenseId] = useState<any>(null);
  const [gridApi, setGridApi] = useState<any>(null);
  const expenseApprovalsDaily: Daily_Expense[] = useSelector(
    approveExpenseStateSelector.getDailyExpenseApprovalsData(),
  );

  const dailyEditedRowColorIndex =
    useSelector(approveExpenseStateSelector.setDailyEditedRowColorIndex()) ??
    [];
  const dailyEditedRowColorIndexArr1 =
    useSelector(
      approveExpenseStateSelector.getDailyEditedRowColorIndexArr1(),
    ) ?? [];
  const SelectedExpenseApprovalsUser = useSelector(
    approveExpenseStateSelector.getSelectedExpenseApprovalsUser(),
  );
  const PopuptadaData = useSelector(
    approveExpenseStateSelector.getPopuptadaData(),
  );
  const status = useSelector(
    approveExpenseStateSelector.getApproveExpensestatus(),
  );
  const dailySort = useSelector(approveExpenseStateSelector.getDailySort());
  const rowVal = () => {
    let datagrid = expenseApprovalsDaily?.map(({dcrDayCode, ...rest}) => ({
      ...rest,
      ['isEditable']: status?.expenseStatusId === 9,
    }));
    return datagrid;
  };
  const [rowData, setRowData] = useState<any>(null);

  useEffect(() => {
    setRowData(rowVal());
  }, [expenseApprovalsDaily, status]);

  useEffect(() => {
    return () => {
      dispatch(approveExpenseStateActions.setDailyEditedRowColorIndex([]));
      dispatch(approveExpenseStateActions.setDailyEditedRowColorIndexArr1([]));
    };
  }, []);

  useEffect(() => {
    return () => {
      dispatch(approveExpenseStateActions.setDailyTableWidth(expandedWidth));
    };
  }, [expandedWidth]);

  useEffect(() => {
    if (gridApi) {
      gridApi.refreshCells({force: true});
    }
  }, [rowData, gridApi]);

  const getRowId = useMemo(() => {
    return (params: any) => params?.data?.id;
  }, []);
  const EditTable = (params: any) => {
    setExpenseId(params?.data?.dcrId);
    dispatch(approveExpenseStateActions.setTaDaPopupVisible(true));
    dispatch(fetchDailyExpensePopupReadOnlyData(params?.data?.dcrId));
    dispatch(fetchDailyExpensePopupTADAData(params?.data?.dcrId));
    dispatch(approveExpenseStateActions.setTaRate(params?.data?.taRate));
    dispatch(approveExpenseStateActions.setexpenseApprovalsViewBillData([]));
  };

  const openMapPopup = (params: any) => () => {
    dispatch(fetchDailyExpenseDcrMapUrlDataCreator(params?.data));
  };
  const onViewBillClickfuntion = (params: any) => {
    let request = {
      id: params?.data?.dcrId,
      page: strings.dialy,
    };
    setExpenseId(params?.data?.dcrId);
    dispatch(fetchBilDetailsCreator(request));
    dispatch(approveExpenseStateActions.setViewBillPopupVisible(true));
  };
  const travelDetails = (params: any) => {
    dispatch(
      approveExpenseStateActions.setTravelDetails(params?.data?.travelItems),
    );
    dispatch(approveExpenseStateActions.setTravelDetailPopup(true));
  };
  const OpenDcrPopup = (params: any) => {
    if (params?.data?.dcrId !== 0) {
      const payload = {
        dcrDate: `${params?.data?.expenseYear}-${params?.data?.expenseMonth}-${params?.data?.expenseDay}`,
        staffPositionId: SelectedExpenseApprovalsUser?.staffPositionId,
        staffUserId: SelectedExpenseApprovalsUser?.staffUserId,
      };
      dispatch(fetchDailyExpenseDcrReportDataCreator(payload));
      dispatch(approveExpenseStateActions.setDcrReportPopupVisible(true));
    }
  };
  const isCellEditable = useCallback(
    (params: any) => {
      return (
        params?.data?.isEditable &&
        params?.data?.activity !== strings.HOLIDAY &&
        params?.data?.activity !== strings.WEEKOFF &&
        params?.data?.activity !== strings.WEEKOFFHOLIDAY &&
        params?.data?.activity !== strings.LEAVE &&
        params?.data?.dcrId != '0' &&
        !params.data.isMultipleTaDaExists &&
        !params?.data?.isWeekOff
      );
    },
    [status],
  );
  const columnTypes = useMemo(() => {
    return {
      valueColumn: {
        editable: true,
        valueParser: 'newValue',
      },
    };
  }, []);
  const style1 = (params: any) => {
    if (isCellEditable(params)) {
      if (dailyEditedRowColorIndexArr1.includes(params.data?.expenseDay)) {
        return {backgroundColor: theme.colors.red[1300]};
      }
      return {backgroundColor: theme.colors.yellow[700]};
    }
  };
  const style = (params: any) => {
    if (isCellEditable(params)) {
      if (dailyEditedRowColorIndex?.includes(params?.data?.expenseDay)) {
        return {backgroundColor: theme.colors.red[1300]};
      }
      return {backgroundColor: theme.colors.yellow[700]};
    }
  };
  const expenseDay = (params: any) => {
    return (
      <Button
        data-testid={`day-${params?.data?.expenseDay}`}
        size="small"
        sx={{p: 0, m: 0, justifyContent: 'left'}}
        onClick={() => OpenDcrPopup(params)}>
        {params?.data?.expenseDay}
      </Button>
    );
  };
  const renderTitle = (params: any) => {
    return (
      <Tooltip
        title={params?.value || ''}
        placement="top"
        arrow
        componentsProps={{
          tooltip: {
            sx: {
              maxWidth: 350,
              fontSize: '11px',
              fontFamily: 'Poppins',
              wordBreak: 'break-word',
              lineHeight: '1.6',
            },
          },
        }}>
        <span
          style={{
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}>
          {params?.value}
        </span>
      </Tooltip>
    );
  };
  const link = (params: any) => {
    return (
      <Link
        title={params?.value}
        className={'toLink'}
        onClick={openMapPopup(params)}>
        {params?.value}
      </Link>
    );
  };
  const travelDetail = (params: any) => {
    const tooltipProps = {
      title: params?.value || '',
      placement: 'top' as const,
      arrow: true,
      componentsProps: {
        tooltip: {
          sx: {
            maxWidth: 350,
            fontSize: '11px',
            fontFamily: 'Poppins',
            wordBreak: 'break-word',
            lineHeight: '1.6',
          },
        },
      },
    };
    if (params?.data?.travelItems?.length > 0) {
      return (
        <Tooltip {...tooltipProps}>
          <Link
            className={'toLink'}
            onClick={() => travelDetails(params)}>
            {params?.value}
          </Link>
        </Tooltip>
      );
    } else {
      return (
        <Tooltip {...tooltipProps}>
          <span
            style={{
              display: 'block',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}>
            {params?.value}
          </span>
        </Tooltip>
      );
    }
  };
  const edit = (params: any) => {
    if (params?.data?.dcrId !== 0) {
      return params?.data?.isMultipleTaDaExists ? (
        <Button
          data-testid={`button-${params?.data?.dcrId}`}
          sx={[
            {color: `${theme.colors.pinkish} !important`},
            Gridstyle.IconButton,
          ]}
          onClick={() => EditTable(params)}>
          <EditIcon />
        </Button>
      ) : (
        <Button sx={[Gridstyle.IconButton]}>
          <EditIcon />
        </Button>
      );
    }
    return null;
  };
  const billPath = (params: any) => {
    if (params?.data?.isBillsUploaded) {
      return !params?.data?.isMultipleTaDaExists ? (
        <VisibilityOutlinedIcon
          data-testid={`outlined-${params?.data?.expenseDetailId}`}
          sx={[
            {color: `${theme.colors.LIGHT_NAVY_BLUE} !important`},
            Gridstyle.IconButton,
          ]}
          fontSize="small"
          onClick={() => onViewBillClickfuntion(params)}
        />
      ) : (
        <VisibilityOutlinedIcon
          data-testid={`outlined-${params?.data?.expenseDetailId}`}
          sx={[
            {color: `${theme.colors.silverish} !important`},
            Gridstyle.IconButton,
          ]}
          fontSize="small"
        />
      );
    }
    return null;
  };

  const sortedDirection = (columnName: string) =>
    columnName === dailySort.sortedField ? dailySort.sortType : '';

  const columns: any = [
    {
      field: strings.moduleSpecificUtilities.expenseDay,
      headerName: strings.moduleSpecificUtilities.Day,
      width: 67,
      pinned: 'left',
      editable: false,
      maxWidth: 100,
      cellRenderer: expenseDay,
      sort: sortedDirection(strings.moduleSpecificUtilities.expenseDay),
    },
    {
      field: strings.moduleSpecificUtilities.activityName,
      headerName: strings.moduleSpecificUtilities.Activity,
      pinned: 'left',
      editable: false,
      width: expandedWidth.activityName,
      maxWidth: 400,
      suppressSizeToFit: true,
      cellRenderer: renderTitle,
      sort: sortedDirection(strings.moduleSpecificUtilities.activityName),
    },
    {
      field: strings.moduleSpecificUtilities.fromStation,
      headerName: strings.moduleSpecificUtilities.FROMSTATION,
      pinned: 'left',
      editable: false,
      width: expandedWidth.fromStation,
      maxWidth: 350,
      suppressSizeToFit: true,
      cellRenderer: renderTitle,
      sort: sortedDirection(strings.moduleSpecificUtilities.fromStation),
    },
    {
      field: strings.moduleSpecificUtilities.toStationDisplayStr,
      headerName: strings.moduleSpecificUtilities.TOSTATION,
      editable: false,
      width: expandedWidth.toStationDisplayStr,
      maxWidth: 600,
      pinned: 'left',
      suppressSizeToFit: true,
      cellRenderer: link,
      sort: sortedDirection(
        strings.moduleSpecificUtilities.toStationDisplayStr,
      ),
    },
    {
      field: strings.HQType,
      headerName: strings.hqType,
      width: 73,
      pinned: 'left',
      maxWidth: 80,
      editable: false,
      sort: sortedDirection(strings.HQType),
    },
    {
      field: strings.moduleSpecificUtilities.distance,
      headerName: strings.DISTANCE,
      width: 78,
      pinned: 'left',
      maxWidth: 200,
      editable: false,
      sort: sortedDirection(strings.moduleSpecificUtilities.distance),
    },
    {
      field: strings.TA,
      headerName: strings.ta,
      width: 80,
      maxWidth: 200,
      editable: false,
      sort: sortedDirection(strings.TA),
    },
    {
      field: strings.moduleSpecificUtilities.taClaimed,
      headerName: strings.moduleSpecificUtilities.TACLAIMED,
      width: 80,
      editable: false,
      maxWidth: 200,
      sort: sortedDirection(strings.moduleSpecificUtilities.taClaimed),
    },
    {
      field: strings.moduleSpecificUtilities.taChangeReason,
      headerName: strings.moduleSpecificUtilities.TACHANGEREASON,
      width: expandedWidth.taChangeReason,
      maxWidth: 400,
      editable: false,
      cellRenderer: travelDetail,
      sort: sortedDirection(strings.moduleSpecificUtilities.taChangeReason),
    },
    {
      field: strings.moduleSpecificUtilities.managerPassedTA,
      headerName: strings.moduleSpecificUtilities.MANAGERPASSEDTA,
      editable: false,
      maxWidth: 107,
      sort: sortedDirection(strings.moduleSpecificUtilities.managerPassedTA),
    },
    {
      field: strings.moduleSpecificUtilities.managerChangeReasonTA,
      headerName: strings.moduleSpecificUtilities.MANAGERREMARKSTA,
      width: expandedWidth.managerChangeReasonTA,
      maxWidth: 450,
      editable: false,
      cellRenderer: renderTitle,
      sort: sortedDirection(
        strings.moduleSpecificUtilities.managerChangeReasonTA,
      ),
    },
    adminPassedDistance(isCellEditable, style, sortedDirection),
    {
      field: strings.moduleSpecificUtilities.adminChangeReasonTA,
      headerName: strings.moduleSpecificUtilities.ADMINCHANGEREASONTA,
      maxWidth: 950,
      width: expandedWidth.adminChangeReasonTA,
      cellEditor: TextInput,
      editable: isCellEditable,
      cellStyle: (params: any) => style(params),
      cellEditorParams: {
        maxLength: 50,
        minLength: 5,
      },
      cellRenderer: renderTitle,
      valueParser: (params: any) => {
        return params?.newValue;
      },
      sort: sortedDirection(
        strings.moduleSpecificUtilities.adminChangeReasonTA,
      ),
    },
    {
      field: strings.moduleSpecificUtilities.adminPassedTA,
      headerName: strings.moduleSpecificUtilities.ADMINPASSEDTA,
      editable: false,
      maxWidth: 100,
      valueGetter: (params: any) => {
        if (
          params?.data?.activity === strings.HOLIDAY ||
          params?.data?.activity === strings.WEEKOFF ||
          params?.data?.activity === strings.WEEKOFFHOLIDAY ||
          params?.data?.activity === strings.LEAVE
        ) {
          return null;
        } else {
          return editedDCRids?.includes(params?.data?.dcrId)
            ? adminPassedTACalculations(params?.data, editedDCRids)
            : params?.data?.adminPassedTA;
        }
      },
      sort: sortedDirection(strings.moduleSpecificUtilities.adminPassedTA),
    },
    {
      field: strings.DA,
      headerName: strings.da,
      editable: false,
      maxWidth: 100,
      sort: sortedDirection(strings.DA),
    },
    {
      field: strings.moduleSpecificUtilities.dAclaimed,
      headerName: strings.moduleSpecificUtilities.DACLAIMED,
      editable: false,
      maxWidth: 101,
      sort: sortedDirection(strings.moduleSpecificUtilities.dAclaimed),
    },
    {
      field: strings.moduleSpecificUtilities.dAchangeReason,
      headerName: strings.moduleSpecificUtilities.DACHANGEREASON,
      editable: false,
      maxWidth: 450,
      width: expandedWidth.dAchangeReason,
      cellRenderer: renderTitle,
      sort: sortedDirection(strings.moduleSpecificUtilities.dAchangeReason),
    },
    {
      field: strings.moduleSpecificUtilities.managerPassedDA,
      headerName: strings.moduleSpecificUtilities.MANAGERPASSEDDA,
      editable: false,
      maxWidth: 120,
      sort: sortedDirection(strings.moduleSpecificUtilities.managerPassedDA),
    },
    {
      field: strings.moduleSpecificUtilities.managerPassedReasonDA,
      headerName: strings.moduleSpecificUtilities.MANAGERREMARKS,
      editable: false,
      maxWidth: 450,
      width: expandedWidth.managerPassedReasonDA,
      cellRenderer: renderTitle,
      sort: sortedDirection(
        strings.moduleSpecificUtilities.managerPassedReasonDA,
      ),
    },
    {
      field: strings.moduleSpecificUtilities.hqTypeAdmin,
      headerName: strings.moduleSpecificUtilities.HQTYPEADMIN,
      maxWidth: 130,
      editable: isCellEditable,
      valueGetter: (params: any) => {
        if (
          params?.data?.hqTypeAdmin == strings.ex ||
          params?.data?.hqTypeAdmin == 'E'
        ) {
          return strings.ex;
        }
        if (
          params?.data?.hqTypeAdmin == strings.home ||
          params?.data?.hqTypeAdmin == 'H'
        ) {
          return strings.home;
        }
        if (
          params?.data?.hqTypeAdmin == strings.out ||
          params?.data?.hqTypeAdmin == 'O'
        ) {
          return strings.out;
        }
        return null;
      },
      cellStyle: (params: any) => {
        if (isCellEditable(params)) {
          return {backgroundColor: theme.colors.yellow[700]};
        }
        return null;
      },
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: {
        cellHeight: 50,
        values: [strings.home, strings.out, strings.ex],
      },
      sort: sortedDirection(strings.moduleSpecificUtilities.hqTypeAdmin),
    },
    {
      field: strings.moduleSpecificUtilities.adminChangeReasonDA,
      headerName: strings.moduleSpecificUtilities.ADMINCHANGEREASONDA,
      maxWidth: 450,
      width: expandedWidth.adminChangeReasonDA,
      cellEditor: TextInput,
      editable: isCellEditable,
      cellStyle: (params: any) => style1(params),
      cellRenderer: renderTitle,
      cellEditorParams: {
        maxLength: 50,
      },
      sort: sortedDirection(
        strings.moduleSpecificUtilities.adminChangeReasonDA,
      ),
    },
    {
      field: strings.moduleSpecificUtilities.adminPassedDA,
      headerName: strings.moduleSpecificUtilities.ADMINPASSEDDA,
      maxWidth: 100,
      editable: isCellEditable,

      valueGetter: (params: any) => {
        return AdminPassedDaConditionalRendering(
          params?.data,
          expenseApprovalsDaily,
          params?.rowIndex,
        );
      },
      cellStyle: (params: any) => {
        if (isCellEditable(params)) {
          return {backgroundColor: theme.colors.yellow[700]};
        }
        return null;
      },
      cellEditor: NumberInput,
      sort: sortedDirection(strings.moduleSpecificUtilities.adminPassedDA),
    },

    {
      field: strings.moduleSpecificUtilities.workWith,
      headerName: strings.moduleSpecificUtilities.WORKWITH,
      editable: false,
      maxWidth: 400,
      width: expandedWidth.workWith,
      cellRenderer: renderTitle,
      sort: sortedDirection(strings.moduleSpecificUtilities.workWith),
    },
    {
      field: strings.moduleSpecificUtilities.noOfDoctors,
      headerName: strings.moduleSpecificUtilities.NOOFDOCTORS,
      editable: false,
      maxWidth: 106,
      sort: sortedDirection(strings.moduleSpecificUtilities.noOfDoctors),
    },
    {
      field: strings.moduleSpecificUtilities.noofChemists,
      headerName: strings.moduleSpecificUtilities.NOOFCHEMISTS,
      editable: false,
      maxWidth: 106,
      sort: sortedDirection(strings.moduleSpecificUtilities.noofChemists),
    },
    {
      field: strings.moduleSpecificUtilities.mainRemark,
      headerName: strings.moduleSpecificUtilities.expenseRemarks,
      editable: false,
      maxWidth: 500,
      cellRenderer: renderTitle,
    },
    {
      field: strings.moduleSpecificUtilities.wsfaRemarks,
      headerName: strings.moduleSpecificUtilities.subRemarks,
      editable: false,
      maxWidth: 500,
      width: expandedWidth.wsfaRemarks,
      cellRenderer: renderTitle,
      sort: sortedDirection(strings.moduleSpecificUtilities.wsfaRemarks),
    },
    {
      field: strings.moduleSpecificUtilities.REMARKS,
      headerName: strings.remarks,
      editable: false,
      maxWidth: 300,
      width: expandedWidth.subRemarks,
      cellRenderer: renderTitle,
      sort: sortedDirection(strings.moduleSpecificUtilities.REMARKS),
    },
    {
      field: strings.moduleSpecificUtilities.taRate,
      headerName: strings.moduleSpecificUtilities.TARATE,
      editable: false,
      maxWidth: 100,
      sort: sortedDirection(strings.moduleSpecificUtilities.taRate),
    },
    {
      field: strings.moduleSpecificUtilities.billPath,
      headerName: strings.moduleSpecificUtilities.BILL,
      editable: false,
      maxWidth: 100,
      cellRenderer: billPath,
      sortable: false,
    },
    {
      field: strings.edit,
      headerName: strings.edit,
      editable: false,
      cellClass: 'noteditable',
      maxWidth: 100,
      cellRenderer: edit,
      sortable: false,
    },
  ];
  const AdminPassedDaConditionalRendering = (
    newRow: any,
    expenseApprovalsDaily: any,
    index: any,
  ) => {
    let value = Number(newRow?.adminPassedDA);
    if (
      expenseApprovalsDaily?.[index]?.hqTypeAdmin &&
      newRow?.hqTypeAdmin !== expenseApprovalsDaily?.[index]?.hqTypeAdmin
    ) {
      if (
        newRow?.hqTypeAdmin === 'E' ||
        (newRow?.hqTypeAdmin === strings.ex && newRow?.daExAmount !== null)
      )
        value = newRow?.daExAmount;
      if (
        newRow?.hqTypeAdmin === 'H' ||
        (newRow?.hqTypeAdmin === strings.home && newRow?.dahqAmount !== null)
      )
        value = newRow?.dahqAmount;
      if (
        newRow?.hqTypeAdmin === 'O' ||
        (newRow?.hqTypeAdmin === strings.out && newRow?.daOutAmount !== null)
      )
        value = newRow?.daOutAmount;
    } else {
      value = newRow?.adminPassedDA;
    }
    return value;
  };
  const look = (
    dcrId: any,
    tempArr: any,
    taVal: any,
    daVAl: any,
    taRes: any,
    daRes: any,
  ) => {
    let looks = PopuptadaData?.map((items: any) => {
      if (items?.dcrId == dcrId) {
        return {
          taDaLookUpId: items?.id,
          adminApprovedAmount:
            items?.expenseCategory == strings.ta ? taVal : daVAl,
          adminRemarks: items?.expenseCategory == strings.ta ? taRes : daRes,
        };
      }
    });
    return looks;
  };

  const hqType = (newRow: any) => {
    if (newRow == strings.ex || newRow == 'E') {
      return 'E';
    }
    if (newRow == strings.home || newRow == 'H') {
      return 'H';
    }
    if (newRow == strings.out || newRow == 'O') {
      return 'O';
    }
  };

  const request = (data: any, expenseApprovalsDaily: any, index: any) => {
    let data1 =
      expenseApprovalsDaily?.[index]?.adminPassedDistance !=
      data?.adminPassedDistance
        ? adminPassedTACalculations(data, index)
        : data?.adminPassedTA;
    let data2 = Number(
      AdminPassedDaConditionalRendering(data, expenseApprovalsDaily, index) ??
        0,
    );
    return {
      dcrId: data?.dcrId,
      adminApprovedTAAmount: data1,
      adminApprovedDAAmount: data2,
      adminApprovedDistance: Number(data?.adminPassedDistance),
      adminApprovedHQType: hqType(data?.hqTypeAdmin) ?? '',
      AdminApprovedTARemarks: data?.adminChangeReasonTA,
      AdminApprovedDARemarks: data?.adminChangeReasonDA,
      staffPositionId: data?.staffPositionId,
      userId: data?.staffUserId,
      month: data?.expenseMonth,
      year: data?.expenseYear,

      saveTaDaLookUp: look(
        data?.dcrId,
        data,
        data1,
        data2,
        data?.adminChangeReasonTA,
        data?.adminChangeReasonDA,
      ),
    };
  };
  const resaonCondi = (oldCode: any, data: any) => {
    if (
      oldCode?.adminPassedDistance == data?.adminPassedDistance &&
      oldCode?.adminChangeReasonTA === data?.adminChangeReasonTA &&
      oldCode?.adminPassedTA === data?.adminPassedTA
    ) {
      if (dailyEditedRowColorIndex.includes(data?.expenseDay)) {
        let updatedChildren = [...dailyEditedRowColorIndex];
        const index = updatedChildren.indexOf(data?.expenseDay);
        if (index !== -1) {
          updatedChildren.splice(index, 1);
        }
        dispatch(
          approveExpenseStateActions.setDailyEditedRowColorIndex(
            updatedChildren,
          ),
        );
      }
    }
  };
  const taCondition = (data: any, oldCode: any, index: any) => {
    if (
      (data?.expenseDay == oldCode.expenseDay &&
        !data?.adminChangeReasonTA &&
        oldCode?.adminPassedDistance != data?.adminPassedDistance) ||
      (!data?.adminChangeReasonTA &&
        oldCode?.adminChangeReasonTA != data?.adminChangeReasonTA)
    ) {
      setEditedDCRids((prev: number[]) => [...prev, data?.dcrId]);
      ToasterService.showToaster(
        strings.moduleSpecificUtilities.AdminChangeReasonTAisMandator,
        ToastType.ERROR,
      );
      if (!dailyEditedRowColorIndex.includes(data?.expenseDay)) {
        dispatch(
          approveExpenseStateActions.setDailyEditedRowColorIndex(
            dailyEditedRowColorIndex.concat(data?.expenseDay),
          ),
        );
      }
      dispatch(approveExpenseStateActions.setDisableaApproveExpense(true));
    }
    if (
      data?.expenseDay == oldCode?.expenseDay &&
      data?.adminChangeReasonTA?.length > 0 &&
      data?.adminChangeReasonTA?.length < 5 &&
      oldCode?.adminChangeReasonTA != data?.adminChangeReasonTA
    ) {
      ToasterService.showToaster(
        strings.moduleSpecificUtilities.minMaxChar,
        ToastType.ERROR,
      );
      setEditedDCRids((prev: number[]) => [...prev, data?.dcrId]);
      if (!dailyEditedRowColorIndex?.includes(data?.expenseDay)) {
        dispatch(
          approveExpenseStateActions.setDailyEditedRowColorIndex(
            dailyEditedRowColorIndex?.concat(data?.expenseDay),
          ),
        );
      }
    }
    resaonCondi(oldCode, data);
  };

  const adminChangeReasonMandCheck = (
    data: any,
    oldCode: any,
    index: number,
  ) => {
    if (
      (!data?.adminChangeReasonDA &&
        oldCode?.adminPassedDA != data?.adminPassedDA) ||
      (!data?.adminChangeReasonDA &&
        oldCode?.hqTypeAdmin != hqType(data?.hqTypeAdmin)) ||
      (!data?.adminChangeReasonDA &&
        oldCode?.adminChangeReasonDA !== data?.adminChangeReasonDA)
    ) {
      ToasterService.showToaster(
        strings.moduleSpecificUtilities.AdminChangeReasonDAisMandatory,
        ToastType.ERROR,
      );
      dispatch(approveExpenseStateActions.setDisableaApproveExpense(true));
      setEditedDCRids((prev: number[]) => [...prev, data?.dcrId]);
      if (!dailyEditedRowColorIndexArr1?.includes(data?.expenseDay)) {
        dispatch(
          approveExpenseStateActions.setDailyEditedRowColorIndexArr1(
            dailyEditedRowColorIndexArr1?.concat(data?.expenseDay),
          ),
        );
      }
    }
    if (
      oldCode?.hqTypeAdmin == hqType(data?.hqTypeAdmin) &&
      oldCode?.adminChangeReasonDA === data?.adminChangeReasonDA
    ) {
      if (dailyEditedRowColorIndexArr1.includes(data?.expenseDay)) {
        let updatedChildren = [...dailyEditedRowColorIndexArr1];
        const index = updatedChildren.indexOf(data?.expenseDay);
        if (index !== -1) {
          updatedChildren.splice(index, 1);
        }
        dispatch(
          approveExpenseStateActions.setDailyEditedRowColorIndexArr1(
            updatedChildren,
          ),
        );
      }
    }
  };

  const condition = (data: any, oldCode: any, index: any) => {
    taCondition(data, oldCode, index);
    adminChangeReasonMandCheck(data, oldCode, index);
    if (
      data?.adminChangeReasonDA?.length > 0 &&
      data?.adminChangeReasonDA?.length < 5 &&
      oldCode?.adminChangeReasonDA != data?.adminChangeReasonDA &&
      (oldCode?.hqTypeAdmin != hqType(data?.hqTypeAdmin) ||
        oldCode?.adminPassedDA != data?.adminPassedDA)
    ) {
      ToasterService.showToaster(
        strings.moduleSpecificUtilities.minMaxChar,
        ToastType.ERROR,
      );
      setEditedDCRids((prev: number[]) => [...prev, data?.dcrId]);
      if (!dailyEditedRowColorIndexArr1?.includes(data?.expenseDay)) {
        dispatch(
          approveExpenseStateActions.setDailyEditedRowColorIndexArr1(
            dailyEditedRowColorIndexArr1?.concat(data?.expenseDay),
          ),
        );
      }
    }

    if (
      data?.adminChangeReasonDA?.length > 0 &&
      data?.adminChangeReasonDA?.length < 5 &&
      oldCode?.adminChangeReasonDA != data?.adminChangeReasonDA &&
      oldCode?.hqTypeAdmin == hqType(data?.hqTypeAdmin) &&
      oldCode?.adminPassedDA == data?.adminPassedDA
    ) {
      ToasterService.showToaster(
        strings.moduleSpecificUtilities.minMaxChar,
        ToastType.ERROR,
      );
      setEditedDCRids((prev: number[]) => [...prev, data?.dcrId]);
      if (!dailyEditedRowColorIndexArr1?.includes(data?.expenseDay)) {
        dispatch(
          approveExpenseStateActions.setDailyEditedRowColorIndexArr1(
            dailyEditedRowColorIndexArr1?.concat(data?.expenseDay),
          ),
        );
      }
    }
    if (
      data?.adminChangeReasonTA &&
      data?.adminChangeReasonTA?.length >= 5 &&
      data?.adminChangeReasonTA?.length <= 50 &&
      oldCode?.adminChangeReasonTA != data?.adminChangeReasonTA
    ) {
      dispatch(approveExpenseStateActions.setDisableaApproveExpense(false));
      dispatch(
        approveExpenseStateActions.setDailyEditedRowColorIndex(
          filterArr(data?.expenseDay, dailyEditedRowColorIndex),
        ),
      );
      setTimeout(() => {
        dispatch(
          fetchDailyExpensePopupTADASaveData(
            request(data, expenseApprovalsDaily, index),
          ),
        );
      }, 500);
    } else if (
      data?.hqTypeAdmin &&
      data?.adminChangeReasonDA &&
      data?.adminChangeReasonDA?.length >= 5 &&
      data?.adminChangeReasonDA?.length <= 50 &&
      oldCode?.adminChangeReasonDA != data?.adminChangeReasonDA
    ) {
      dispatch(
        approveExpenseStateActions.setDailyEditedRowColorIndexArr1(
          filterArr(data?.expenseDay, dailyEditedRowColorIndexArr1),
        ),
      );
      setTimeout(() => {
        dispatch(
          fetchDailyExpensePopupTADASaveData(
            request(data, expenseApprovalsDaily, index),
          ),
        );
      }, 500);
    }
  };
  const filterArr = (expenseDay: any, arr: any) => {
    return arr?.filter((user: any) => user !== expenseDay);
  };

  const modifiedEmployees = (data: any, oldCode: any, index: any) => {
    return expenseApprovalsDaily?.map(obj => {
      if (obj?.dcrId == data?.dcrId) {
        return {
          ...obj,
          adminPassedDistance: Number(data?.adminPassedDistance),
          adminPassedTA:
            oldCode?.adminPassedDistance != data?.adminPassedDistance
              ? adminPassedTACalculations(data, index)
              : data?.adminPassedTA,
          adminChangeReasonTA: data?.adminChangeReasonTA,
          hqTypeAdmin: hqType(data?.hqTypeAdmin),
          adminChangeReasonDA: data?.adminChangeReasonDA,
          adminPassedDA: Number(
            AdminPassedDaConditionalRendering(
              data,
              expenseApprovalsDaily,
              index,
            ) ?? 0,
          ),
        };
      }
      return obj;
    });
  };
  const onRowValueChanged = useCallback(
    (event: any) => {
      dispatch(approveExpenseStateActions.setDailyTableWidth(expandedWidth));
      let data = event?.data;
      const index = expenseApprovalsDaily?.findIndex(
        (element: {expenseDay: any}) =>
          element?.expenseDay === data?.expenseDay,
      );

      let oldCode = expenseApprovalsDaily?.[index];
      if (
        oldCode?.adminPassedDistance != data?.adminPassedDistance &&
        data?.adminChangeReasonTA?.length >= 5 &&
        data?.adminChangeReasonTA?.length <= 50
      ) {
        dispatch(approveExpenseStateActions.setDisableaApproveExpense(false));
        dispatch(
          approveExpenseStateActions.setDaAmountCalculations(
            modifiedEmployees(data, oldCode, index),
          ),
        );
        dispatch(approveExpenseStateActions.setDailyEditedRowColorIndex([]));
        dispatch(approveExpenseStateActions.setDeductAmount({}));
        setTimeout(() => {
          dispatch(
            fetchDailyExpensePopupTADASaveData(
              request(data, expenseApprovalsDaily, index),
            ),
          );
        }, 500);
      } else if (
        (oldCode?.hqTypeAdmin != data?.hqTypeAdmin &&
          data?.adminChangeReasonDA?.length >= 5 &&
          data?.adminChangeReasonDA?.length <= 50) ||
        (Number(oldCode?.adminPassedDA) != Number(data?.adminPassedDA) &&
          data?.adminChangeReasonDA?.length >= 5 &&
          data?.adminChangeReasonDA?.length <= 50)
      ) {
        dispatch(approveExpenseStateActions.setDeductAmount({}));
        dispatch(approveExpenseStateActions.setDisableaApproveExpense(false));
        dispatch(
          approveExpenseStateActions.setDaAmountCalculations(
            modifiedEmployees(data, oldCode, index),
          ),
        );
        dispatch(
          approveExpenseStateActions.setDailyEditedRowColorIndexArr1([]),
        );
        setTimeout(() => {
          dispatch(
            fetchDailyExpensePopupTADASaveData(
              request(data, expenseApprovalsDaily, index),
            ),
          );
        }, 500);
      } else {
        condition(data, oldCode, index);
      }
    },
    [expenseApprovalsDaily, rowData, PopuptadaData, expandedWidth],
  );

  const onRowEditingStarted = useCallback(
    event => {
      // setDcr_Id(event.data.dcrId)
      dispatch(fetchDailyExpensePopupTADAData(event?.data?.dcrId));
    },
    [rowData],
  );

  const handleColumnResized = (event: any) => {
    if (!event?.column) {
      return;
    }
    const {column} = event;
    setExpandedWidth((prev: any) => ({
      ...prev,
      [column?.colId]: column.getActualWidth(),
    }));
  };

  const handleColumnResizedDebounce = debounce(handleColumnResized, 200);

  const onSortedChange = (params: any) => {
    const sortedColumns = params.columnApi
      .getAllColumns()
      .filter((col: any) => col.getSort());
    if (sortedColumns.length > 0) {
      const sortedColumn = sortedColumns[0];
      const sortedField = sortedColumn.getColId();
      const sortType = sortedColumn.getSort();
      const dailySort = {
        sortedField,
        sortType,
      };
      dispatch(approveExpenseStateActions.setDailySort(dailySort));
    } else {
      const test = {
        sortedField: '',
        sortType: '',
      };
      dispatch(approveExpenseStateActions.setDailySort(test));
    }
  };

  const _onGridReady = (params: any) => {
    setGridApi(params.api);
  };

  util.onRowValueChanged = onRowValueChanged;
  util.onRowEditingStarted = onRowEditingStarted;
  util.style1 = style1;
  util.style = style;
  util.AdminPassedDaConditionalRendering = AdminPassedDaConditionalRendering;
  return (
    <>
      <div
        data-testid="grid-react"
        className="ag-theme-alpine"
        style={{height: 370}}>
        <AgGridReact
          rowData={rowData}
          columnDefs={columns}
          getRowId={getRowId}
          onRowValueChanged={onRowValueChanged}
          onRowEditingStarted={onRowEditingStarted}
          onColumnResized={handleColumnResizedDebounce}
          columnTypes={columnTypes}
          editType={'fullRow'}
          getRowStyle={colorChange}
          enableRangeSelection={true}
          copyHeadersToClipboard={true}
          enableCellTextSelection={true}
          rowHeight={20}
          onSortChanged={onSortedChange}
          onGridReady={_onGridReady}
          defaultColDef={{
            sortable: true,
            cellDataType: false,
            resizable: true,
            suppressMovable: true,
          }}></AgGridReact>

        <Box>
          <InsufficentFundPopup />
          <DcrModal />
          <TADAPopup setExpenseId={setExpenseId} />
          <TravleDetail />
        </Box>
      </div>

      {
        <ViewBillPopup
          isComingFromDailyGrid={true}
          expenseId={expenseId}
          setExpenseId={setExpenseId}
        />
      }
      <div style={{marginTop: 2}}>
        {nameColor?.map((item: any) => {
          return (
            <span key={item?.name} style={referColor}>
              <span style={nameStyles(`${item?.color}`)}></span> {item?.name}
            </span>
          );
        })}
      </div>
    </>
  );
};

export default ApproveExpenseDailyGrid;
export const nameColor = [
  {
    name: strings.WEEKOFFHOLIDAYLEAVE,
    color: theme.colors.LIGHT_GREEN,
  },
  {
    name: strings.POLICYVIOLATION,
    color: theme.colors.pink[300],
  },
  {
    name: strings.EDITABLEROW,
    color: theme.colors.yellow[700],
  },
];
export const adminPassedTACalculations = (newRow: any, index: any) => {
  const clculatedValue =
    Number(newRow?.adminPassedDistance) * Number(newRow?.taRate);
  const formattedResult =
    clculatedValue % 1 !== 0 ? clculatedValue?.toFixed(1) : clculatedValue;
  return formattedResult;
};
export const adminPassedDACalulations = (
  newRow: any,
  index: any,
  expenseApprovalsDaily: any,
) => {
  if (newRow?.hqTypeAdmin !== expenseApprovalsDaily?.[index]?.hqTypeAdmin) {
    if (newRow?.hqTypeAdmin === 'E') {
      return hqTypeE_Selected(newRow);
    }
    if (newRow?.hqTypeAdmin === 'H') {
      return hqTypeHQ_Selected(newRow);
    }
    if (newRow?.hqTypeAdmin === 'O') {
      return hqTypeO_Selected(newRow);
    }
    return Number(newRow?.adminPassedDA);
  }
};
export const hqTypeE_Selected = (newRow: any) => {
  let value = 0;
  if (newRow?.daExAmount !== null) {
    value = newRow?.daExAmount;
  }
  return value;
};
export const hqTypeHQ_Selected = (newRow: any) => {
  let value = 0;
  if (newRow?.dahqAmount !== null) {
    value = newRow?.dahqAmount;
  }
  return value;
};
export const hqTypeO_Selected = (newRow: any) => {
  let value = 0;
  if (newRow?.daOutAmount !== null) {
    value = newRow?.daOutAmount;
  }
  return value;
};
